// extracted by mini-css-extract-plugin
module.exports = {"input":"MovePlayerModal_input__2LqTZ","select":"MovePlayerModal_select__Sarm1"};